import { all } from "redux-saga/effects";
import * as types from "../actionTypes/bussiness.types";

// Calls
import {
  fetchBusinessRequest,
  updateBusinessProfileRequest
} from "../../api/calls/business.call";
import { fetchActiveSubscriptionRequest } from "../../api/calls/subscription.call";

// Actions
import {
  fetchBusinessDataSuccess,
  updateBusinessProfileSuccess,
  updateBusinessProfileFailed,
  fetchActiveSubscriptionSuccess
} from "../actions/business.actions";

import { fetchSaga } from "./fetch.saga";

export default function* bussinessSaga() {
  yield all([
    fetchSaga({
      trigger: types.FETCH_BUSINESS_REQUEST,
      apiCall: fetchBusinessRequest,
      onSuccess: r => fetchBusinessDataSuccess(r),
      failedType: types.FETCH_BUSINESS_FAILED
    })(),
    fetchSaga({
      trigger: types.UPDATE_BUSINESS_PROFILE_REQUEST,
      apiCall: updateBusinessProfileRequest,
      args: a => [a.businessProfileFormValues, a.businessProfileInitialValues],
      onSuccess: r => updateBusinessProfileSuccess(r),
      onFailed: r => updateBusinessProfileFailed(r)
    })(),
    fetchSaga({
      trigger: types.FETCH_ACTIVE_SUBSCRIPTION_REQUEST,
      apiCall: fetchActiveSubscriptionRequest,
      onSuccess: r => fetchActiveSubscriptionSuccess(r.activeSubscription),
      failedType: types.FETCH_ACTIVE_SUBSCRIPTION_FAILED
    })()
  ]);
}
